import { normalizeHex } from './colorUtils';

const cache = new Map();

const rgbToHex = (r, g, b) => {
  const clamp = (value) => Math.max(0, Math.min(255, value));
  const toHex = (value) => clamp(value).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
};

const bucketColor = (value) => (value >> 4) << 4;

export const extractPhotoColors = (src, count = 8) => {
  if (!src || typeof window === 'undefined') return Promise.resolve([]);
  if (cache.has(src)) return Promise.resolve(cache.get(src));

  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const size = 64;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        resolve([]);
        return;
      }
      ctx.drawImage(img, 0, 0, size, size);
      const data = ctx.getImageData(0, 0, size, size).data;
      const buckets = new Map();
      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];
        if (alpha < 20) continue;
        const r = bucketColor(data[i]);
        const g = bucketColor(data[i + 1]);
        const b = bucketColor(data[i + 2]);
        const key = `${r},${g},${b}`;
        buckets.set(key, (buckets.get(key) || 0) + 1);
      }
      const sorted = [...buckets.entries()]
        .sort((a, b) => b[1] - a[1])
        .slice(0, count)
        .map(([key]) => {
          const [r, g, b] = key.split(',').map(Number);
          return normalizeHex(rgbToHex(r + 8, g + 8, b + 8));
        })
        .filter(Boolean);

      cache.set(src, sorted);
      resolve(sorted);
    };
    img.onerror = () => resolve([]);
    img.src = src;
  });
};

export const clearPhotoColorCache = () => {
  cache.clear();
};
